export default __webpack_public_path__ + "static/media/445.74cc9aa7.png";